import { Injectable } from '@angular/core';
import { Product } from '@core/models/piramide/Product';
import { FC_GabineteFuente } from '../funcionesCompatibilidad/FC_GabineteFuente';
import { FC_MotherFuente } from '../funcionesCompatibilidad/FC_MotherFuente';
import { FC_VideoFuente } from '../funcionesCompatibilidad/FC_VideoFuente';
import { Incompatibilities } from '../Incompatibilities';
import { Disco, Fuente } from '../model';
import { DataArmado } from './DataArmado';
import { FuncionesArmadoBase } from './FuncionesArmadoBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';
@Injectable({
  providedIn: 'root',
})
export class FA_Fuente extends FuncionesArmadoBase<Fuente> {
  constructor(
    private fc_videoFuente: FC_VideoFuente,
    private fc_motherFuente: FC_MotherFuente,
    private fc_gabineteFuente: FC_GabineteFuente,
  ) {
    super();
  }
  funciones = {
    mother: (dataArmado: DataArmado, fuente: Fuente) => {
      const motherEnArmado = dataArmado.mother[0];
      if (!motherEnArmado) return [];
      return this.fc_motherFuente.ejecutar(motherEnArmado, fuente);
    },
    video: (dataArmado: DataArmado, fuente: Fuente) => {
      const videoEnArmado = dataArmado.placasVideos;
      if (!videoEnArmado.length) return [];
      return videoEnArmado.reduce((array, placa) => {
        array.push(...this.fc_videoFuente.ejecutar(placa, fuente));
        return array;
      }, []);
    },
    gabinete: (dataArmado: DataArmado, fuente: Fuente) => {
      const gabinete = dataArmado.gabinetes[0];
      if (!gabinete) return [];
      return this.fc_gabineteFuente.ejecutar(gabinete, fuente);
    },
    capacidad: (dataArmado: DataArmado, fuente: Fuente): Incompatibilities[] => {
      let productosSeleccionados: Product[] = [].concat.apply([], Object.values(dataArmado));
      let consumo = productosSeleccionados.reduce(
        (consumo, producto) => consumo + (producto.$caracteristicas.w ?? 0),
        0,
      );
      return fuente.$caracteristicas.w_real > consumo ?
          null
        : [
            {
              tipo: IncompatibilitiesType.ARMADO,
              incompatibility: `La fuente no tiene la capacidad requerida, el consumo máximo que soporta es ${fuente.$caracteristicas.w_real}`,
            },
          ];
    },

    capacidadPinesPlacas: (dataArmado: DataArmado, fuente: Fuente): Incompatibilities[] | null => {
      const placasSeleccionadas = dataArmado.placasVideos;
      if (!placasSeleccionadas.length) return [];
      // se genera objeto local de fuente
      let $fuente = {
        _16pines: fuente.$caracteristicas.pcie_16pines,
        pcie: fuente.$caracteristicas.pines_pcie,
        pcieplus: fuente.$caracteristicas.pines_pcieplus,
      };

      // se genera objeto local de placas de video
      const valoresTotalesPlacas = placasSeleccionadas.reduce(
        (acumulador, video) => {
          acumulador._16pines += video.$caracteristicas._16pines || 0;
          acumulador._16pines_adaptadores += video.$caracteristicas.adaptador_16pines || 0;
          acumulador._16pinesCantidadConexion += video.$caracteristicas._16pines_conexion || 0;
          acumulador._16pinesCablesPorAdaptador +=
            video.$caracteristicas.adaptador_16pines ||
            0 * video.$caracteristicas._16pines_conexion ||
            0;
          if (!video.$caracteristicas._16pines) {
            acumulador._2plusNecesarios += video.$caracteristicas._2plus || 0;
            acumulador._6pinesNecesarios += video.$caracteristicas._6pines || 0;
          }
          return acumulador;
        },
        {
          _16pines: 0,
          _16pines_adaptadores: 0,
          _16pinesCantidadConexion: 0,
          _16pinesCablesPorAdaptador: 0,
          _2plusNecesarios: 0,
          _6pinesNecesarios: 0,
        },
      );

      // en caso de que SI se tengan los 16 pines en video
      if (valoresTotalesPlacas._16pines) {
        // se restan los pines de la fuente a los de la placa para saber cuantos adaptadores necesito
        let adaptadoresNecesarios = valoresTotalesPlacas._16pines - $fuente._16pines;

        // estas son las cantidades de conexiones de la fuente
        let cantidadConexionesFuente = Math.min($fuente.pcie, $fuente.pcieplus);

        // si los adaptadores de la placa no son los necesarios para cubrir a la fuente

        if (valoresTotalesPlacas._16pines_adaptadores < adaptadoresNecesarios) {
          return [
            {
              tipo: IncompatibilitiesType.PRODUCTO,
              incompatibility: 'Pines de fuente insuficientes',
            },
          ];
        }
        // si los adaptadores de la placa SI son los necesarios para cubrir a la fuente
        else {
          // se chequean las cantidades de conexiones de la fuente, y si son menores que los de la placa tira incompatibilidad
          console.log(cantidadConexionesFuente, valoresTotalesPlacas._16pinesCantidadConexion);

          if (cantidadConexionesFuente < valoresTotalesPlacas._16pinesCantidadConexion) {
            return [
              {
                tipo: IncompatibilitiesType.PRODUCTO,
                incompatibility: 'Pines de fuente insuficientes',
              },
            ];
          }
        }
      }
      // en el caso de que no se tengan los 16 pines en video
      else {
        if (
          $fuente.pcieplus >= valoresTotalesPlacas._2plusNecesarios &&
          $fuente.pcie >= valoresTotalesPlacas._6pinesNecesarios
        ) {
          return null;
        } else {
          return [
            {
              tipo: IncompatibilitiesType.PRODUCTO,
              incompatibility: 'Pines de fuente insuficientes',
            },
          ];
        }
      }
      return null;
    },
    capacidadDiscosSATA: (dataArmado: DataArmado, fuente: Fuente): Incompatibilities[] => {
      let discos: Disco[] = dataArmado.discos.filter(
        (d) => d.$caracteristicas.interfaz.toLowerCase() == 'sata',
      );
      if (!discos?.length) return null;
      return fuente.$caracteristicas.sata < discos?.length ?
          [
            {
              tipo: IncompatibilitiesType.CANTIDAD,
              incompatibility:
                fuente.$caracteristicas.sata > 0 ?
                  `La fuente no soporta mas de ${fuente.$caracteristicas.sata} discos SATA`
                : 'La fuente no soporta discos SATA',
            },
          ]
        : null;
    },
  };
}
